import { FieldState, FormState } from 'formstate'
import { minLength, required } from '../../utils/forms'

class SendCreditConfirmationForm {
  fields = {
    smsCode: new FieldState('').validators(required, minLength(6)),
  }

  form = new FormState(this.fields)

  serialize = () => {
    return {
      smsCode: this.fields.smsCode.$,
    }
  }
}

export { SendCreditConfirmationForm }
